<template>
  <ButtonTemplateMicInput :on-click="confirmHangUp" :text-button="t('end_of_call')">
    <template #icon-handler>
      <IconExit />
    </template>
  </ButtonTemplateMicInput>
</template>

<script setup lang="ts">
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';

import ButtonTemplateMicInput from '@/components/domains/chat/common/ButtonTemplateMicInput.vue';
import IconExit from '@/components/icons/IconExit.vue';
import { useHangUpCommon } from '@/composables/domains/chat/useHangupCommon';
import { ij_setBottomBarStatus } from '@/utils/injectionKeys';

const setBottomBarStatus = inject(ij_setBottomBarStatus) as (newVal: number) => void;

const emit = defineEmits<{ exit: [] }>();

const { t } = useI18n();
const { confirmHangUp } = useHangUpCommon({
  setBottomBarStatus,
  emitClose: emit('exit'),
});
</script>

<style scoped lang="scss"></style>
